import { render } from "./ExpandableList.vue?vue&type=template&id=3f95c2f1"
import script from "./ExpandableList.vue?vue&type=script&lang=js"
export * from "./ExpandableList.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__